import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Share2, Menu, X, ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { fetchPosts } from "../../../../../../../redux/blogSlice";
import { AppDispatch, RootState } from "../../../../../../../redux/store";

const samVideo = require("../../../../../../../assets/videos/samVideo.mp4");

const News: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { posts } = useSelector((state: RootState) => state.blog);
  const sortedPosts = [...posts].sort((a, b) => {
    const dateA = new Date(a.createdAt?.seconds ? a.createdAt.seconds * 1000 : a.createdAt);
    const dateB = new Date(b.createdAt?.seconds ? b.createdAt.seconds * 1000 : b.createdAt);
    return dateB.getTime() - dateA.getTime(); // Newest to oldest
  });
  
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!posts.length) dispatch(fetchPosts());
  }, [dispatch, posts.length]);

  const handleShare = (post: any) => {
    const url = `${window.location.origin}/${post.slug}`;
    if (navigator.share) {
      navigator.share({
        title: post.title,
        text: post.description,
        url,
      });
    } else {
      navigator.clipboard.writeText(url);
      alert("Link copied to clipboard");
    }
  };

  const handleScrollDown = () => {
    document.getElementById("news-section")?.scrollIntoView({ behavior: "smooth" });
  };

  const year = new Date().getFullYear();
  const visiblePosts = sortedPosts.slice(0, 8);

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <div style={styles.menuIcon} onClick={() => setMenuOpen(true)}>
          <Menu size={24} color="#fff" />
        </div>
        <h2 style={styles.logo}>ARELUXE News</h2>
      </div>

      {menuOpen && (
        <div style={styles.sideMenu}>
          <div style={styles.closeIcon} onClick={() => setMenuOpen(false)}>
            <X size={28} color="#fff" />
          </div>
          <h3 style={styles.menuText}>Menu</h3>
        </div>
      )}

      <div style={styles.videoContainer}>
        <video autoPlay loop muted style={styles.video}>
          <source src={samVideo} type="video/mp4" />
        </video>
        <div style={styles.overlay}>
          <h1 style={styles.heroTitle}>All Real Estate</h1>
          <p style={styles.heroSubtitle}>
             where realestate luxury meets creativity.
          </p>
          <button style={styles.learnMoreBtn} onClick={() => navigate("/about")}>Learn More</button>
          <div onClick={handleScrollDown} style={styles.scrollDownBtn}>
            <ChevronDown size={32} color="#fff" />
          </div>
        </div>
      </div>

      <div id="news-section" style={styles.grid}>
        {visiblePosts.map((post) => {
          const createdAt = post.createdAt
            ? new Date(typeof post.createdAt === "string" ? post.createdAt : post.createdAt.seconds * 1000)
            : null;

          return (
            <div
              key={post.id}
              style={styles.card}
              onMouseEnter={(e) => (e.currentTarget.style.border = "2px solid #ffbf00")}
              onMouseLeave={(e) => (e.currentTarget.style.border = "2px solid transparent")}
            >
              <div style={styles.cardImageWrap}>
                <img src={post.featuredImage} alt={post.title} style={styles.cardImage} />
                <div style={styles.overlayIcon} onClick={() => handleShare(post)}>
                  <Share2 size={16} color="#fff" />
                </div>
              </div>
              <div style={styles.cardContent}>
                <span style={styles.category}>{post.category}</span>
                <h3 style={styles.title}>{post.title}</h3>
                <p style={styles.description}>{post.description}</p>
                {createdAt && <p style={styles.time}>{createdAt.toLocaleString("en-GB", { day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit", timeZoneName: "short" })}</p>}
                <button
                  style={styles.viewMoreBtn}
                  onMouseEnter={(e) => e.currentTarget.style.background = 'linear-gradient(135deg, #ff007d, white, silver)'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'linear-gradient(135deg, #bf9b30, white, silver)'}
                  onClick={() => navigate(`/${post.slug}`)}
                >
                  View More
                </button>
              </div>
            </div>
          );
        })}

        <div style={{ textAlign: "center", marginTop: 32 }}>
          <button style={styles.nextBtn} onClick={() => navigate("/MoreNews")}>See All News</button>
        </div>
      </div>


{/*About Glam*/}

<div style={styles.aboutSection}>
  <h2 style={styles.sectionTitle}>Explore</h2>
  <div style={styles.linkGrid}>
    <div style={styles.linkColumn}>
      <h4>About Us</h4>
      <ul style={styles.linkList}>
      <li onClick={() => navigate("/pages/about-us")}>About ARELUXE</li>
<li onClick={() => navigate("/pages/support")}>Contact & Support</li>
<li onClick={() => navigate("/pages/privacy")}>Privacy & Policy</li>
<li onClick={() => navigate("/pages/terms")}>Terms </li>


        <li onClick={() => navigate("/services")}>Our Premium Services</li>
        <li onClick={() => navigate("/testimonials")}>TrustPilot Testimonials</li>

      </ul>
    </div>
    <div style={styles.linkColumn}>
      <h4>Premium Experiences</h4>
      <ul style={styles.linkList}>

        <li onClick={() => navigate("/events")}>Event Teams</li>
        <li onClick={() => navigate("/shoots")}>Photo/Video Shoots</li>
        <li onClick={() => navigate("/hospitality")}>VIP Hospitality</li>
      </ul>
    </div>
    <div style={styles.linkColumn}>
      <h4>Discover</h4>
      <ul style={styles.linkList}>
        <li onClick={() => navigate("/partners")}>Our Partners</li>
        <li onClick={() => navigate("/events")}>Upcoming Events</li>
        <li onClick={() => navigate("/News")}>Blog</li>
        <li onClick={() => navigate("/careers")}>Careers</li>
      </ul>
    </div>
    <div style={styles.linkColumn}>
      <h4>Support</h4>
      <ul style={styles.linkList}>
        <li onClick={() => navigate("/faq")}>FAQs</li>
        <li onClick={() => navigate("/contact-us")}>Live Chat</li>
        <li onClick={() => navigate("/pages/help-support")}>Help Center</li>
        <li onClick={() => navigate("/feedback")}>Send Feedback</li>
      </ul>
    </div>
  </div>
</div>



<div style={styles.footer}>© COSMETA {year}</div>
</div>
  );
};

export default News;





const styles: { [key: string]: React.CSSProperties } = {
  page: {
    background: "linear-gradient(160deg, #000000, #1a1a1a)",
    minHeight: "100vh",
    paddingBottom: 80,
    paddingTop: 56,
    position: "relative",
    overflowX: "hidden",
  },
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    background: "#000",
    color: "#ffdc73",
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    zIndex: 1000,
  },
  menuIcon: { marginRight: 12, cursor: "pointer" },
  logo: { fontSize: 18, fontWeight: 700 },
  sideMenu: {
    position: "fixed",
    top: 0,
    left: 0,
    background: "#ffdc73",
    width: "100vw",
    height: "100vh",
    zIndex: 2000,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  closeIcon: { position: "absolute", top: 20, right: 20, cursor: "pointer" },
  menuText: { fontSize: 24, color: "#fff", fontWeight: "bold" },
  videoContainer: {
    position: "relative",
    width: "100%",
    height: "100vh",
    overflow: "hidden",
  },
  video: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    filter: "blur(4px) brightness(0.7)",
    zIndex: 1,
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    textAlign: "center",
    padding: "0 20px",
  },
  heroTitle: { fontSize: 48, fontWeight: "bold", marginBottom: 12 },
  heroSubtitle: { fontSize: 20, maxWidth: 600, marginBottom: 20 },
  learnMoreBtn: {
    padding: "10px 20px",
    borderRadius: 8,
    background: "linear-gradient(135deg, #bf9b30, white, silver)",
    color: "#000",
    fontWeight: "bold",
    fontSize: 14,
    border: "none",
    marginBottom: 20,
    cursor: "pointer",
  },
  scrollDownBtn: {
    backgroundColor: "#000",
    borderRadius: "50%",
    padding: 8,
    cursor: "pointer",
    boxShadow: "0 0 10px #bf9b30",
  },
  grid: {
    display: "grid",
    gap: 30,
    padding: 30,
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  },
  card: {
    background: "linear-gradient(145deg, #000000, #1a1a1a)",

    borderRadius: 16,
    overflow: "hidden",
    border: "2px solid transparent",
    transition: "border 0.3s ease, box-shadow 0.3s ease",
    boxShadow: "0 0 16px rgba(255, 191, 0, 0.1)",
  },
  cardImageWrap: {
    position: "relative",
    width: "100%",
    height: 180,
  },
  cardImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
  },
  overlayIcon: {
    position: "absolute",
    top: 12,
    right: 12,
    background: "#000",
    padding: 8,
    borderRadius: "50%",
    boxShadow: "0 0 10px #bf9b30",
    cursor: "pointer",
  },
  cardContent: {
    padding: 20,
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  category: {
    alignSelf: "flex-start",
    fontSize: 12,
    color: "#bf9b30",
    padding: "2px 10px",
    borderRadius: 20,
    border: "1px solid #bf9b30",
    fontWeight: 600,
    textTransform: "uppercase",
  },
  title: { fontSize: 20, fontWeight: "bold" },
  description: { fontSize: 14, color: "#ccc" },
  time: { fontSize: 12, fontStyle: "italic", color: "#aaa" },
  nextBtn: {
    padding: "10px 20px",
    background: "#ffdc73",
    color: "#fff",
    border: "none",
    borderRadius: 24,
    fontSize: 14,
    cursor: "pointer",
  },
  footer: {
    background: "#000",
    color: "#aaa",
    textAlign: "center",
    padding: "20px 0",
    fontSize: 13,
    borderTop: "1px solid #333",
  },


  //about
  viewMoreBtn: {
    marginTop: 12,
    padding: "10px",
    borderRadius: 8,
    background: "linear-gradient(135deg, #bf9b30, white, silver)",
    color: "#000",
    fontWeight: "bold",
    fontSize: 14,
    border: "none",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
  aboutSection: {
    padding: "60px 20px",
    background: "#000",
    color: "#fff",
    textAlign: "center",
  },
  sectionTitle: {
    fontSize: 32,
    fontWeight: "bold",
    color: "#bf9b30",
    marginBottom: 20,
  },
  linkGrid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "40px",
    marginTop: 20,
  },
  linkColumn: {
    flex: "1 1 200px",
    textAlign: "left",
  },
  linkList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    color: "#bf9b30",
    cursor: "pointer",
    fontSize: "15px",
  },
  
};